import React, { useEffect } from 'react';
import {
  Box, Container, IconButton,
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Images from '../../../../Configs/images';
import ROUTES from '../../../../Configs/routes';
import Elements from '../../../Elements';
import Fragments from '../../../Fragments';
import { getUserData } from '../../../../Utils/storages';
import { getWallet } from '../../../../Redux/Models/user';
import Colors from '../../../../Configs/colors';

export default function Home({ classes }) {
  const navigate = useNavigate();
  const user = getUserData();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(getWallet(user.id));
  }, []);

  return (
    <Elements.PageBase>
      <div className={classes.root}>
        <section className="top-section">
          <Box className="content">
            <Container>
              <div className="flex space-between align-items-center">
                <h1>
                  <img src={Images.LogoWhite} alt="Logo" height="27" />
                </h1>
                <div>
                  <IconButton
                    sx={{ bgcolor: Colors.yellow }}
                    size="small"
                    onClick={() => navigate(ROUTES.profile())}
                  >
                    <img src={Images.MyProfile} alt="my profile" />
                  </IconButton>
                </div>
              </div>
              <Box className="weight-700 white" mt={2}>
                Hi,
                {' '}
                {user.front_name || user.username}
              </Box>
              <Box mt={1}>
                <Elements.Balance />
              </Box>
            </Container>
          </Box>
        </section>
        <Box mt={3}>
          <Fragments.AdsCarousel />
        </Box>

        <section className="flex space-around mt-6">
          <Link className="center link black" to={ROUTES.requestStorage()}>
            <img height={28} width={28} src={Images.IconRequestIn} alt="Request" />
            <div className="s-10 weight-600">{t('common.reqIn')}</div>
          </Link>
          <Link className="center link black" to={ROUTES.history()}>
            <img height={28} width={28} src={Images.IconHistory} alt="History" />
            <div className="s-10 weight-600">{t('homePage.history')}</div>
          </Link>
          <Link className="center link black" to={ROUTES.mySubscription()}>
            <img height={28} width={28} src={Images.IconSubscription} alt="Subscription" />
            <div className="s-10 weight-600">{t('common.subs')}</div>
          </Link>
        </section>

        <Box mt={3}>
          <Fragments.TrackingProgress />
        </Box>

        {/* <Box mt={3}>
          <Fragments.InformationCarousel />
        </Box> */}

        {/* <Box mt={3}>
          <Fragments.AcademyCarousel />
        </Box> */}

        <Box mt={3}>
          <Elements.Footer />
        </Box>

      </div>
    </Elements.PageBase>
  );
}
